import { render, staticRenderFns } from "./CopyrightCounter.vue?vue&type=template&id=42bef51e&scoped=true&"
import script from "./CopyrightCounter.vue?vue&type=script&lang=js&"
export * from "./CopyrightCounter.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightCounter.vue?vue&type=style&index=0&id=42bef51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bef51e",
  null
  
)

export default component.exports